import { render, staticRenderFns } from "./userTaskProgress.vue?vue&type=template&id=71fac329&scoped=true&"
import script from "./userTaskProgress.vue?vue&type=script&lang=js&"
export * from "./userTaskProgress.vue?vue&type=script&lang=js&"
import style0 from "./userTaskProgress.vue?vue&type=style&index=0&id=71fac329&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fac329",
  null
  
)

export default component.exports